import { oz } from '@weft/utils';
import { CommitmentUsageReportItemSchema } from './commitment-usage-report-item-schema';

export const CommitmentUsageReportSchema = oz.array(CommitmentUsageReportItemSchema).openapi('GetCommitmentReportResponseSchema');

export type CommitmentUsageReport = oz.TypeOf<typeof CommitmentUsageReportSchema>;